import React, { Component } from 'react';
import { AppCollapsible } from '../AppCollapsible';
import './terms.css';
import  { connect } from 'react-redux';
import { editInputWithProps } from '../../../redux/actions/inputWithProps';
import { AppModal } from '../AppModal';
import { AppInputWrapper } from '../AppInputWrapper';

let setCheckboxColor = (color) => ({
    borderBottomColor: color,
    borderRightColor: color,
});

class TermsAndConditions extends Component {

    state = {
        label: this.props.initialValues.label || 'Terms & Conditions',
        title: this.props.initialValues.title || 'Terms & Conditions',
        required: this.props.initialValues.isRequired || false,
        checked: false,
        terms: this.props.initialValues.terms || 'Terms...',
        showModal: false,
        requiredError: !!this.props.initialValues.isRequired,
    };

    updateInputPropsInStore = () => {
        const { label, title, required, checked, terms, requiredError } = this.state;

        const inputProps = {
            type: this.props.initialValues.type,
            terms,
            label,
            title,
            isRequired: required,
            _value: String(checked),
            _hasValidationErrors: requiredError,
        };

        this.props.editInputWithProps(this.props.initialValues.id, inputProps);
    };

    componentDidMount() {
        setTimeout(_ => {
            this.updateInputPropsInStore();
        }, 500);
    }

    componentDidUpdate() {
        this.updateInputPropsInStore();
    }

    setTerms = (e) => {
        this.setState({ terms: e.target.value });
    };

    setLabel = (e) => {
        this.setState({ label: e.target.value });
    };

    setTitle = (e) => {
        this.setState({ title: e.target.value });
    };

    setRequired = (e) => {
        this.setState({ required: e.target.checked });
    };

    hideModal = () => {
        this.setState({ showModal: false });
    };

    showModal = () => {
        this.setState({ showModal: true });
    };

    onCloseModal = (val) => {
        if (val !== undefined) {
            this.setState({
                checked: val,
                requiredError: this.state.required ? !val : false
            });
        }
        this.hideModal();
    };

    onCheck = (e) => {
        this.setState({
            checked: e.target.checked,
            requiredError: this.state.required ? !e.target.checked : false
        });
    };

    render() {
        const { color, textColor, isResultInput } = this.props;
        return (
                <>
                    <AppModal
                        showModal={this.state.showModal}
                        onCloseModal={this.onCloseModal}
                        config={{
                            title: this.state.label,
                            message: this.state.terms
                        }}
                    />

                    <AppInputWrapper
                        color={textColor}
                        labelFontSize={'18px'}
                        label={this.state.label}
                        required={this.state.required}
                        requiredError={this.state.requiredError}
                    >
                        <div>
                            <label
                                className="checkbox-container"
                                style={{ marginLeft: '5px', color: textColor }}
                            >
                                I agree to the
                                <input value={this.state.checked} type="checkbox" onChange={this.onCheck} />
                                <span className="checkmark">
                                    <span
                                        style={setCheckboxColor(this.state.checked ? color : '#fff')}
                                        className="checked-terms"
                                    />
                                </span>
                            </label>
                            <span
                                className="terms-link"
                                onClick={this.showModal}
                                style={{ color: textColor }}
                            >{ this.state.title }</span>
                        </div>
                    </AppInputWrapper>

                    {
                        !isResultInput &&
                        <AppCollapsible>
                            <div className="settings-container">

                                <label>
                                    <input value={this.state.label} onChange={this.setLabel} type="text"/>
                                    label
                                </label>

                                <label>
                                    <input value={this.state.title} onChange={this.setTitle} type="text"/>
                                    title
                                </label>

                                <label>
                                    <input checked={this.state.required} onChange={this.setRequired} type="checkbox"/>
                                    required
                                </label>
                                <textarea
                                    rows="8"
                                    cols="50"
                                    value={this.state.terms}
                                    onChange={this.setTerms}
                                />
                            </div>
                        </AppCollapsible>
                    }
                </>
        );
    }
}

export default connect(
    () => ({}),
    {
        editInputWithProps
    }
)(TermsAndConditions)
